// extracted by mini-css-extract-plugin
export default {"root":"Modal_root__EeBKj","opacity":"Modal_opacity__aq1ar","modal":"Modal_modal__yEgVW","close":"Modal_close__nnot4"};